//import * as React from 'react';


export const tenure = [

 "1 YEAR",
 "2 YEARS",
 "3 YEARS",
 "4 YEARS",
 "5 YEARS"
];
export default tenure




